import { render } from "./CounselorsReport.vue?vue&type=template&id=f659084e&scoped=true"
import script from "./CounselorsReport.vue?vue&type=script&lang=js"
export * from "./CounselorsReport.vue?vue&type=script&lang=js"

import "./CounselorsReport.vue?vue&type=style&index=0&id=f659084e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f659084e"]])

export default __exports__